import * as React from "react";
import { PreJobCheckListV2 } from "../../../generated/nest-graphql";
import { Text, TextVariant } from "../../ui";
import { InspectionRowLabel, inspectionRows } from "../inspectionRows.utils";
import { InvoicedService } from "../vehicleHistoryData";
import { COLUMNS, InvoicedMark } from "./inspectionSummary.utils";
import { Heading, HeadingAlign } from "./Heading";
import { Row } from "./Row";

/** A visit's inspection readings and notes, as the job card's Inspection side shows them. */
export const InspectionSummary: React.FC<{
  checklist: PreJobCheckListV2;
  /** Each item the same job's invoice covers, with those services; such rows open to show them. */
  invoiced?: Map<InspectionRowLabel, InvoicedService[]>;
  /** Items the job's quoted services cover; quoted but not invoiced shows an empty circle. */
  quoted?: Set<InspectionRowLabel>;
}> = ({ checklist, invoiced, quoted }) => {
  const rows = inspectionRows(checklist).filter((row) => !!row.value);
  return (
    <>
      {/* A visit with only notes has no rows. */}
      {rows.length > 0 && (
        <div className="px-3 py-1">
          {/* Column headings, like a table: the inspected item, what it measured, and whether it was invoiced. */}
          <div className="grid items-center gap-2 py-1.5 border-b border-[#44576e]" style={COLUMNS}>
            <Heading>Service</Heading>
            <Heading>Result</Heading>
            <Heading align={HeadingAlign.CENTER}>Invoiced</Heading>
          </div>
          {rows.map((row) => (
            <Row
              key={row.label}
              label={row.label}
              value={row.value}
              grade={row.grade}
              mark={
                invoiced?.has(row.label) ? InvoicedMark.INVOICED : quoted?.has(row.label) ? InvoicedMark.QUOTED : null
              }
              services={invoiced?.get(row.label)}
            />
          ))}
        </div>
      )}
      {checklist.privateNotes && (
        <div className={rows.length > 0 ? "px-3 py-3 border-t border-[#44576e]" : "px-3 py-3"}>
          <Text variant={TextVariant.BODY2} className="text-gray-400">
            Notes
          </Text>
          <Text variant={TextVariant.BODY2}>{checklist.privateNotes}</Text>
        </div>
      )}
    </>
  );
};
